@if (certificationId() && icon()) {
  <apm-icon size="md" [icon]="icon()!"></apm-icon>
}
